import React from 'react';
import { t } from 'Src/i18n';
import { ChildcareDescription } from 'Components/widgets/childcare-description/ChildcareDescription';
import { getServiceAgesLabel } from 'Components/utils/product/product.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { DurationSlotsLabels } from 'Utils/childcare/childcare.utils';
import { getSpecificChildcareLabel, rentedTotalPriceByChild } from './ChildcareSummary.utils';

export const ChildcareSummary = ({ childcares }) => {
  const childcaresFiltered = childcares.filter((childcare) => {
    const { childId, attendees } = childcare.pricingInfo;
    const { isIncluded } = childcare.productInfo;
    const currentChildInfo = attendees.find(({ id }) => id === childId);
    return currentChildInfo?.rentedAmount?.value > 0 || isIncluded;
  });
  if (childcaresFiltered.length === 0) {
    return null;
  }

  return (
    <div className="mt-30">
      {childcaresFiltered.map((childcare, idx) => {
        const { label, description, ageInMonths } = childcare.productInfo;

        const { childId, attendees } = childcare.pricingInfo;
        const currentChildInfo = attendees.find(({ id }) => id === childId);
        const currentChildRentedAmout = currentChildInfo?.rentedAmount;

        const childcareRentedSpecificLabel = getSpecificChildcareLabel(currentChildInfo);

        const childcareTitle = `${label} - ${childcareRentedSpecificLabel}`;
        const rentedOrPaidTimeSlots = currentChildInfo.schedules[0].timeSlots.filter(
          ({ isRented, isPaid }) => isRented || isPaid,
        );

        return (
          <React.Fragment key={childcare.id}>
            <p className="mb-10 mt-0 text-20 font-bold">
              {`${t('booking.confirmation.child')} ${idx + 1}`}
            </p>
            <div className="mb-20 rounded-12 bg-white p-20 shadow-sm">
              <div className="flex items-end justify-between">
                <div className="flex w-full">
                  <div className="flex w-full justify-between">
                    <div className="flex w-4/5 flex-col">
                      <p className="text-brand text-blue mb-20 mt-0 font-bold">{childcareTitle}</p>
                      <div className="flex items-center gap-10">
                        <Icon name="duration" width="0.9375em" />
                        <DurationSlotsLabels
                          timeSlots={childcare.productInfo.timeSlots || []}
                          closingWeekdays={childcare.productInfo.closingWeekdays || []}
                          rentedOrPaidTimeSlots={rentedOrPaidTimeSlots}
                          showOnlyRentedOrPaid
                        />
                      </div>
                      <div className="flex items-center gap-10">
                        <Icon name="dateStar" width="0.9375em" />
                        <p className="text-14">{getServiceAgesLabel(ageInMonths)}</p>
                      </div>
                    </div>
                    <div className="flex flex-col text-right">
                      <p className="font-bold">
                        {rentedTotalPriceByChild(childcare, currentChildRentedAmout)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <ChildcareDescription description={description} />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
